<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>留学攻略</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <!-- 分类 -->
        <el-form-item label="分类">
          <el-cascader :options="treelist" v-model="cateQueryList" clearable :props="{ value: 'id', label: 'label' }"
            @change="cascaderClick()"></el-cascader>


        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>留学攻略</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%"
          :tree-props="{ children: 'children' }">
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="author" label="作者"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="publishTime" label="发布时间" width="160"></el-table-column>
          <el-table-column label="置顶" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isTop" type="danger">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="分类">
            <template slot-scope="scope">
              {{ scope.row.cateID1Name }} {{ scope.row.cateID2Name }}
            </template>
          </el-table-column>
          <el-table-column label="是否精选">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.isSelected == true">是</el-tag>
              <el-tag type="success" v-else>否</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框  form表单的点击事件 submitForm-->
    <el-dialog :title="form.id > 0 ? '编辑留学攻略' : '添加留学攻略'" :visible.sync="dialogVisible" @opened="dialogOpened()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-form-item label="标题" prop="title" :rules="[
          { required: true, message: '请输入问题标题' },
          { min: 2, max: 30, message: '标题最少2字，最大30字' },
        ]">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="imgUrl" :rules="[{ required: true, message: '请输入图片' }]">
          <div id="uploadBtn1" class="uploader uploader-warning"></div>
          <img id="relativeName" :src="domain + form.imgUrl"
            style="height: 40px; position: relative; left: 10px; top: 20px" v-if="form.imgUrl" />
          <div class="uploader-text">* 图片尺寸：推荐372px*279px</div>
        </el-form-item>
        <!-- <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="分类"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-cascader
                :options="treelist"
                v-model="cateList"
                clearable
                :props="{ value: 'id', label: 'label' }"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row> -->



        <el-form-item label="作者" prop="author">
          <el-input v-model="form.author" placeholder="请输入作者"></el-input>
        </el-form-item>

        <el-form-item label="排序字段" prop="sort">
          <el-input v-model.number="form.sort" placeholder="请输入排序字段"></el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发布时间">
              <el-date-picker v-model="form.publishTime" type="datetime" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="置顶">
              <el-switch v-model="form.isTop"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="是否精选">
              <el-switch v-model="form.isSelected"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="内容" prop="content">
          <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: { VueUeditorWrap },
  data() {
    return {
      editorConfig: {
        initialFrameHeight: 500, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      domain: url.getDomain(),
      key: "",
      query: { articleType: "1" },
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      treelist: [], // 
      cateList: [], //类型列表 加接收参数1 
      cateQueryList: [], //类型列表
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    addClick() {
      this.form = {
        isSelected: false,
        isTop: false,
        articleType: 1,
        sort: 0
      };
      this.cateList = [];
      this.dialogVisible = true;
    },
    cascaderClick() {
      if (this.cateQueryList.length == 0) {
        this.query.cateid = undefined;
      } else {
        this.query.cateid = this.cateQueryList[1];
      }
      this.getList();
    },
    // 查询列表 C#分页接口方法1 
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      var link = url.getStrategy("getlist_strategy");

      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询函数
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //获取攻略类型列表
    strategy: function () {
      var _this = this;
      var link = url.getSys_BasicData("GetBaseTree");
      $.get(link, { modelid: 2 }, (data) => {
        _this.treelist = data;
      });
    },
    //上传图片
    dialogOpened: function () {
      var _this = this;

      // 上传图片
      if ($("#uploadBtn1 input").length == 0) {
        $("#uploadBtn1").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          type: "dialog",
          coverParams: {
            targetWidth: 372,
            targetHeight: 279,
          },
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            _this.$set(_this.form, "imgUrl", data.relativeName);
          },
        });
      }
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getStrategy("save_strategy");
      var info = this.form;
      info.cateID1 = this.cateList[0];
      info.cateID2 = this.cateList[1];
      info.articleType = 1;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.cateList = [row.cateID1, row.cateID2];
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getStrategy("delete_strategy");
      var id = row.id;

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    this.strategy();
    this.getList();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.el-form-item--small.el-form-item {
  margin-right: 0px;
}

.el-button--primary {
  margin-left: 10px;
}
</style>
